import { render, staticRenderFns } from "./CameraSettings.vue?vue&type=template&id=0c488b14&scoped=true&"
import script from "./CameraSettings.vue?vue&type=script&lang=js&"
export * from "./CameraSettings.vue?vue&type=script&lang=js&"
import style0 from "./CameraSettings.vue?vue&type=style&index=0&id=0c488b14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c488b14",
  null
  
)

component.options.__file = "CameraSettings.vue"
export default component.exports